// #region Imports

import * as $ from "jquery";

// #endregion Imports

// #region Exports

export function initialize(): void {
    wireSlider();
}

// #endregion Exports

// #region Private members

let $target: JQuery<Node>;

// #endregion Private members

// #region Private functions

function wireSlider(): void {
    const $slider = $('.js-simple-slider');
    $target = $($slider.data('target'));

    $target.data('slide', 0);
    $target.data('count', $target.children().length);

    $slider.find('.js-prev').click(gotoPreviousSlide);
    $slider.find('.js-next').click(gotoNextSlide);

    $(window).resize(resizeWindow);
}

function resizeWindow() {
    $target
        .css('transform', 'translateX(0)')
        .data('slide', 0);
}

function gotoPreviousSlide(e) {
    e.preventDefault();

    gotoRelativeSlide(-1);
}

function gotoNextSlide(e) {
    e.preventDefault();

    gotoRelativeSlide(1);
}

function gotoRelativeSlide(steps:Number) {

    let slide = $target.data('slide');
    const count = $target.data('count');

    slide += steps;
    if (slide >= count) {
        slide = 0;
    }
    if (slide < 0) {
        slide = count - 1;
    }

    $target
        .css('transform', 'translateX(-' + slide * 100 + 'vw)')
        .data('slide', slide);
}

// #endregion Private functions